"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

var _axios = _interopRequireDefault(require("axios"));

var _routers = _interopRequireDefault(require("@/router/routers"));

var _elementUi = require("element-ui");

var _store = _interopRequireDefault(require("../store"));

var _auth = require("@/utils/auth");

var _settings = _interopRequireDefault(require("@/settings"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var pendingMap = new Map();
var REQUEST_TIME_LIMIT = 3000;

function generatePendingKey(config) {
  var method = config.method,
      url = config.url,
      params = config.params,
      data = config.data;
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&');
}
/**
 * 统一解析请求的 pending key。
 * 优先使用请求发出时记录在 config 上的 key：axios 在 dispatchRequest 阶段
 * 会把对象类型的 data 序列化成字符串，若在响应/错误阶段再用 config.data
 * 重新拼接 key，结果与请求阶段不一致，会导致 pendingMap 记录无法被删除，
 * 后续相同请求被误判为重复请求并一直挂起。
 */


function resolvePendingKey(config) {
  if (!config) return '';
  if (config.__pendingKey) return config.__pendingKey;
  var method = config.method,
      url = config.url,
      params = config.params,
      data = config.data; // 兜底：data 已被序列化为字符串时不再二次 JSON.stringify

  var normalizedData = typeof data === 'string' ? data : JSON.stringify(data);
  return [method, url, JSON.stringify(params), normalizedData].join('&');
}

function checkPending(config) {
  var pendingKey = resolvePendingKey(config);

  if (pendingMap.has(pendingKey)) {
    var _pendingMap$get = pendingMap.get(pendingKey),
        time = _pendingMap$get.time;

    var now = Date.now();

    if (now - time < REQUEST_TIME_LIMIT) {
      return true;
    }
  }

  return false;
}

function removePending(config) {
  if (!config) return;
  var pendingKey = resolvePendingKey(config);

  if (pendingMap.has(pendingKey)) {
    var _pendingMap$get2 = pendingMap.get(pendingKey),
        cancel = _pendingMap$get2.cancel;

    cancel('取消重复请求');
    pendingMap.delete(pendingKey);
  }
}

function deletePending(config) {
  if (!config) return;
  var pendingKey = resolvePendingKey(config);
  pendingMap.delete(pendingKey);
}

var service = _axios.default.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/',
  timeout: _settings.default.timeout
});

service.interceptors.request.use(function (config) {
  var isValidMethod = ['get', 'post', 'put', 'delete'].includes(config.method);
  var isGetRequest = isValidMethod && config.method === 'get';

  if (!isGetRequest) {
    var pendingKey = generatePendingKey(config); // 记录请求阶段生成的 key，供响应/错误阶段清理 pendingMap 时复用

    config.__pendingKey = pendingKey;

    if (pendingMap.has(pendingKey)) {
      var _pendingMap$get3 = pendingMap.get(pendingKey),
          time = _pendingMap$get3.time;

      var now = Date.now();

      if (now - time < REQUEST_TIME_LIMIT) {
        // 不能返回永不 settle 的 Promise，否则调用方 await 会永久挂起（loading 卡死）
        return Promise.reject(new _axios.default.Cancel('重复请求已取消，请稍后重试'));
      }

      removePending(config);
    }

    config.cancelToken = new _axios.default.CancelToken(function (cancel) {
      pendingMap.set(pendingKey, {
        cancel: cancel,
        time: Date.now()
      });
    });
  }

  if ((0, _auth.getToken)()) {
    config.headers['Authorization'] = (0, _auth.getToken)();
  }

  config.headers['Content-Type'] = 'application/json';
  return config;
}, function (error) {
  Promise.reject(error);
}); // response 拦截器

service.interceptors.response.use(function (response) {
  deletePending(response.config);
  return response.data;
}, function (error) {
  if (_axios.default.isCancel(error)) {
    console.log('重复请求已取消');
    deletePending(error.config); // 必须把取消错误继续抛给调用方，否则组件的 await 永不结束、loading 无法复位

    return Promise.reject(error);
  } else {
    deletePending(error.config);
  } // 兼容blob下载出错json提示


  if (error.response && error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
    var reader = new FileReader();
    reader.readAsText(error.response.data, 'utf-8');

    reader.onload = function (e) {
      var errorMsg = JSON.parse(reader.result).message;

      _elementUi.Notification.error({
        title: errorMsg,
        duration: 5000
      });
    };
  } else {
    var code = 0;

    try {
      code = error.response && error.response.data && error.response.data.status;
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        _elementUi.Notification.error({
          title: '网络请求超时',
          duration: 5000
        });

        return Promise.reject(error);
      }
    }

    console.log(code);

    if (code) {
      if (code === 401) {
        _store.default.dispatch('LogOut').then(function () {
          // 用户登录界面提示
          _jsCookie.default.set('point', 401);

          location.reload();
        });
      } else if (code === 403) {
        _routers.default.push({
          path: '/401'
        });
      } else {
        var errorMsg = error.response && error.response.data && error.response.data.message;

        if (errorMsg !== undefined) {
          _elementUi.Notification.error({
            title: errorMsg,
            duration: 5000
          });
        }
      }
    } else {
      _elementUi.Notification.error({
        title: '接口请求失败',
        duration: 5000
      });
    }
  }

  return Promise.reject(error);
});
var _default = service;
exports.default = _default;